class HHBlogImageGallery extends HTMLElement {
  constructor() {
    super()

    this.thumbsGallery = null;
    this.mainGallery = null;
    this.thumbs = this.querySelectorAll('.js-blog-gallery-thumb');
  }

  connectedCallback() {
    this.init();
    this.addListeners();
  }

  addListeners() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('keydown', this.handleThumbKeyDown.bind(this));
      thumb.addEventListener('click', this.handleThumbClick.bind(this));
    })
  }

  handleThumbKeyDown(e) {
    if (e.code === 'Space' || e.code === 'Enter') {
      const index = Number.parseInt(e.currentTarget.getAttribute('data-slide-index'));
      if (Number.isNaN(index)) {
        return;
      }

      this.mainGallery.slideTo(index);
    }
  }

  handleThumbClick(e) {
    const index = Number.parseInt(e.currentTarget.getAttribute('data-slide-index'));
    if (Number.isNaN(index)) {
      return;
    }

    this.mainGallery.slideTo(index);
  }

  init() {
    this.thumbsGallery = new Swiper(".js-blog-gallery-thumbs", {
      spaceBetween: 6,
      slidesPerView: 4,
      watchSlidesProgress: true,
      threshold: 10,
      a11y: {
        slideLabelMessage: "Scroll to slide {{index}} of {{slidesLength}}",
      },
      breakpoints: {
        750: {
          spaceBetween: 10,
          slidesPerView: 5,
        }
      },
    });

    this.mainGallery = new Swiper(".js-blog-gallery-main", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".js-swiper-button-next",
        prevEl: ".js-swiper-button-prev",
      },
      thumbs: {
        swiper: this.thumbsGallery,
      },
      loop: true
    });
  }
}

customElements.define('hh-blog-image-gallery', HHBlogImageGallery)